var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';
import classNames from 'classnames';

import './Badge.scss';

var Badge = function Badge(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'default' : _ref$type,
        rest = _objectWithoutProperties(_ref, ['children', 'className', 'type']);

    var classes = classNames('badge', type !== 'default' ? 'badge-' + type : '', className);

    return React.createElement(
        'span',
        _extends({ className: classes }, rest),
        children
    );
};

Badge.propTypes = {
    /** Child components */
    children: PropTypes.node.isRequired,

    /** A predefined badge type */
    type: PropTypes.oneOf(['info', 'warning', 'highlight', 'error', 'alert', 'success']),

    /** Adds a class to the component */
    className: PropTypes.string
};
export default Badge;
import PropTypes from 'prop-types';